<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="28" height="25" viewBox="0 0 28 25" fill="none">
    <path d="M21.7621 0.296875H25.9042L16.8572 10.6346L27.5 24.7037H19.1688L12.6389 16.173L5.17601 24.7037H1.02803L10.7027 13.6443L0.5 0.296875H9.04237L14.9387 8.09414L21.7621 0.296875ZM20.307 22.2278H22.601L7.7927 2.64368H5.32855L20.307 22.2278Z" fill="white"/>
  </svg>
</template>
